<template>
  <div class="yunxiao teacher old-student-input" data-test="old-student-input">
    <div class="contain full-page">
      <p
        v-if="isRepetitive"
        @click="$router.push('/baseStudentNameRepetitive?scoped=意向或学员&old=true')"
        class="repetitive-tips"
      >
        有可能重复的意向或学员
        <span>点击查看></span>
      </p>
      <!-- <p
        v-if="confirmNotRepetitive"
        class="repetitive-tips"
        @click="$router.push('/baseStudentNameRepetitive?scoped=意向或学员&old=true')"
      >
        已忽略可能重复的意向或学员
        <span >重新选择></span>
      </p> -->

      <div class="line-title" style="display: flex;">
        学员信息
      </div>
      <van-field
        v-model="studentInfos.name"
        @blur="validateName"
        required
        ref="studentNameInput"
        label="姓名"
        maxlength="50"
        input-align="right"
        :formatter="v => v.trimLeft()"
        placeholder="请填写学生姓名"
      />
      <div class="info-wrapper">
        <div class="info-item">
          <div class="item-label">性别</div>
          <div class="item-right">
            <van-radio-group v-model.number="studentInfos.sex" direction="horizontal">
              <van-radio :name="1" @click="sexClickFn(1)">男</van-radio>
              <van-radio :name="0" @click="sexClickFn(0)">女</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="info-item">
          <div class="item-label">出生日期</div>
          <div
            class="item-right"
            @click="chooseDate"
            :class="{ placeholder: !studentInfos.birthday }"
          >
            <span class="item-value">
              {{ studentInfos.birthday || '请选择' }}
            </span>
            <van-icon name="clear" class="item-icon" v-if="studentInfos.birthday" @click.stop="studentInfos.birthday = ''"/>
            <van-icon class="item-icon" name="arrow" v-else/>
          </div>
        </div>
        <!-- <div class="info-item">
          <div class="item-label required">当前公立年级</div>
          <div
            class="item-right"
            @click="pickerGrade"
            :class="{ placeholder: !studentInfos.gradeName }"
          >
            <span class="item-value">
              {{ studentInfos.gradeName || '请选择' }}
            </span>
            <van-icon class="item-icon" name="arrow" />
          </div>
        </div> -->
        <custom-fields class="custom-fields-nav" :fields="formatFields(customFieldList)" ref="customFields" />
      </div>
      <div class="line-title required" style="margin-top: calc(var(--gap) * 12)">
        联系人信息
        <van-popover
          v-model="showPopover2"
          trigger="click"
          placement="top-start"
          theme="dark"
          :offset="[-8, 4]"
        >
          用下面填写的号码注册学员端账号可查看学员上课信息，请正确填写手机号码
          <template #reference>
            <van-icon name="question-o" class="tips-icon" />
          </template>
        </van-popover>
      </div>
      <div class="info-wrapper">
        <div class="right-column-tips">
          设为常用联系人
        </div>
        <van-field class="parent-field" v-for="(item, idx) of studentInfos.relationTels" :key="idx">
          <template #label>
            <div
              class="relation-nav"
              :class="{ placeholder: !item.relation }"
              @click="pickerRelation(idx)"
            >
              <i class="required-relation" v-if="item.often"></i>
              <van-icon
                v-if="studentInfos.relationTels.length > 1 && !item.often"
                class="delete-relation"
                class-prefix="vxs-icon"
                name="system_del"
                size="16"
                color="var(--c3)"
                @click.stop="studentInfos.relationTels.splice(idx, 1)"
            />
              {{ item.relation || '请选择' }}
              <van-icon name="arrow-down" size="var(--fs-lg)"/>
            </div>
          </template>
          <template #input>
            <van-field
              class="input-solt-field"
              v-model="item.parentPhone"              
              @blur="validateName"
              clearable
              name="phone"
              type="tel"
              input-align="left"
              maxlength="11"
              :formatter="(v)=>v.replace(/[^0-9]/g, '')"
              placeholder="请输入手机号码"
              :border="false"
            />
            <div class="right-radio-column" :class="{active: item.often}" @click="changeOften(item)">
              <div class="circle"></div>
            </div>
          </template>
        </van-field>
        <div
          class="info-item add-btns"
          @click="studentInfos.relationTels.push({
              relation: '妈妈',
              parentPhone: '',
            })">
          <i class="vxs-icon vxs-icon-system_add"></i>新增联系方式
        </div>
      </div>
      <div class="line-title" style="margin-top:calc(var(--gap)*12)" >
        跟进信息
        <van-popover
          v-model="showPopover0"
          trigger="click"
          placement="top-start"
          theme="dark"
          :offset="[-8, 4]">
          跟进老师可在“学员”管理中查看此学员信息，非跟进老师无法查看（设置了可查看“全部数据”的除外）。
          <template #reference>
            <van-icon name="question-o" class="tips-icon" />
          </template>
        </van-popover>
      </div>       
      <div class="info-wrapper" style="margin-bottom: calc(var(--gap)*32)" >
        <van-field
        readonly
        required
        v-model="studentInfos.campusName"
        label="登记校区"
        :right-icon="'arrow'"
        input-align="right"
        placeholder="请选择"
        @click.stop="x3chooseCampus()"
      />
        <van-cell v-for="(tea, idx) in studentInfos.followTeacherList" :key="tea.id">
          <div class="relation-nav">
            <van-icon
              class="delete-relation"
              class-prefix="vxs-icon"
              name="system_del"
              size="16"
              color="var(--c3)"
              @click="delFollowTeacher(idx)"
            />
            {{ tea.followTeacherName || "请选择" }}
          </div>
        </van-cell>
        <div class="info-item add-btns" @click="selectFollowTeacher">
          <i class="vxs-icon vxs-icon-system_add"></i>选择跟进人
        </div>
      </div>
      <div class="info-wrapper" style="margin: calc(var(--gap) * 12) 0 calc(var(--gap) * 32)">
        <van-cell class="check-cell"  title="同步新增意向" >
          <van-switch 
            v-model="addIntentionClue" 
            size="26" 
            :active-value="1" 
            :inactive-value="0"  />
        </van-cell>
        <div class="block top" v-if="addIntentionClue">
          <van-field
            class="content-textarea"
            type="textarea"
            v-model="intentionClue.content"
            rows="3"            
            maxlength="20"
            placeholder="请输入意向课程"
            :formatter="(v) => v.trimLeft()"
          />
          <van-field  class="level-input" >
            <template #input>
              <span style="padding-right: calc(var(--gap) *15);">成交意向</span>
              <van-rate
                v-model="intentionClue.level"
                icon="like"
                void-icon="like-o"
                :size="20"
                color="var(--c1)"
              />
            </template>
          </van-field>
        </div>
      </div>
    </div>
    <page-footer-btn multipleBtns>
      <van-button
        square round
        block
        type="primary"
        @click="inputSubmit()"
        data-test="old-student-input-btn-next"
      >
        下一步
      </van-button>
    </page-footer-btn>
    <duplicateDialog v-model="showDialog" :datas="duplicateDatas" />
  </div>
</template>

<script>
import customField from "@teacher/mixins/customField.js";
import customFields from "@teacher/components/custom-fields.vue";
import duplicateDialog from "@teacher/components/duplicate-dialog.vue";
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";

export default {
  name: 'oldStudentInfosInput',
  mixins: [customField({businessType:'STUDENT_OFFICIALLY'})],
  components: {
    customFields,
    duplicateDialog,
    pageFooterBtn
  },
  data () {
    return {
      pageTitle: '在读学员录入',
      isRepetitive: false,
      confirmNotRepetitive: false,
      studentInfos: {
        campusId: app.teacher.campusId, // 校区id
        campusName: app.teacher.campus.name,
        name: '',
        sex: 2,
        birthday: '',
        gradeName: '',
        followTeacherList: [{
          followTeacherId: this.$store.state.userInfo.id,
          followTeacherName: this.$store.state.userInfo.name,
        }],
        relationTels: [
          {
            relation: '妈妈',
            parentPhone: '',
            often: true,
          },
        ],
      },
      addIntentionClue: 0,
      intentionClue: {
        level: 0,
        content: '',
      },
      duplicateDatas: [],
      showDialog: false,
      showPopover0: false,
      showPopover2: false,
      oldSexValue: 2,
      duplicateClueData: null
    }
  },
  created() {
    // 确认过不是重名的名字，不再验证
    // this.$onBus('studentInputNameRepetitiveConfirm', this.noRepetitiveNameConfirm);
    this.$onBus('studentInputNameRepetitiveConfirm', ()=> {
      this.confirmNotRepetitive = true;
      this.inputSubmit();
    })
  },
  methods: {
    formatFields(list){
      list && list.forEach(item=> {
        if (item.fieldDataType == 5 && !item.valueList) {
          this.$set(item, 'valueList', []);
        }
      })
      return list;
    },
    async x3chooseCampus() {
      let res = await app.x3.side.xsCampus({
        id: this.studentInfos.campusId,
        config: {
          enableAdd: true,
          must: true,
        },
      });
      if (res.id !== this.studentInfos.campusId) {
        this.studentInfos.followTeacherList.splice(0);
      }
      this.studentInfos.campusId = res ? res.id : '';
      this.studentInfos.campusName = res ? res.name : '';
    },
    // noRepetitiveNameConfirm ()  {
    //   this.confirmNotRepetitive = true;
    // },
    // 选择出生日期
    chooseDate(v) {
      app.x3.picker
        .datetime({
          type: 'date',
          'min-date': new Date('1900-01-01'),
          value: new Date(this.studentInfos.birthday.replace(/\-/g, '/') || '2010/01/01'),
        })
        .then(res => {
          this.studentInfos.birthday = app.tool.date.filterDate(res);
        });
    },
    // 选择学生公立年级
    // pickerGrade() {
    //   app.x3.picker.grade({ dictCode: this.studentInfos.grade + '' }).then(res => {
    //     this.studentInfos.grade = res.dictCode;
    //     this.studentInfos.gradeName = res.dictName;
    //   });
    // },
    /**
     * 验证学员名称是否重复
     */
    validateName() {
      this.$refs.studentNameInput && this.$refs.studentNameInput.blur();
      this.studentInfos.name = this.studentInfos.name.trim();
      let { name } = this.studentInfos;

      let phoneList = this.studentInfos.relationTels.filter(({parentPhone})=>parentPhone).map(({parentPhone})=>parentPhone);
      this.isRepetitive = false;
      this.confirmNotRepetitive = false;
      this.duplicateClueData = null;
      this.nameValidating = this.$api
        .checkDuplicateClue({
          checkEnableAddOrUpdate: true,
          name: name.trim(),
          phoneList,          
          checkScope: 3,
          studentType: 1 // 应用场景：1学员操作2意向操作
        })
        .then(res => {
          if (res.code === 200) {
            let len = res.data.intentionClueList.length + res.data.studentList.length;
            app.ls.setStorage('student-input-repetitive-datas', res.data);
            app.ls.setStorage('student-input-repetitive-params', {name: name.trim() || '', phoneList: phoneList||[]});
            this.isRepetitive = !!len;
            this.duplicateClueData = res.data;
          }

          this.nameValidating = false;
        })
        .catch(err => {
          console.log(err);
          this.nameValidating = false;
        });
    },
    /**
     * 清空重名验证数据，重新验证一次重复
     * 在学员登记接口完成后进行，防止用户回退后同一数据重复提交
     */
    reValidateName() {
      this.isRepetitive = false;
      this.confirmNotRepetitive = false;
      this.duplicateClueData = null;
      this.validateName();
    },
    /**
     * 提交学员信息 进入下一步
     */
    async inputSubmit() {
      let { name, relationTels } = this.studentInfos;
      if (name.trim().length == 0) {
        this.$toast('请输入学员姓名。');
        this.$refs.studentNameInput && this.$refs.studentNameInput.focus();
        return false;
      }
      
      if (this.$refs['customFields']) {
        if (!this.$refs['customFields'].validate()) {
          return false;
        }
      }
      // 找出填写未完整的手机号码的关系
      let validatedTels = relationTels.filter(v => {
        return !/^\d{11}$/.test(v.parentPhone);
      });
      // 存在填写未正确的手机号码
      if (validatedTels.length) {
        this.$toast('联系方式有误，请核对填写内容');
        return false;
      }
      // 校验是否存在重复的手机号码
      let telObj = {};
      for (let { parentPhone } of relationTels) {
        if (telObj[parentPhone]) {
          this.$toast('联系方式重复，请核对填写内容');
          return false;
        }
        telObj[parentPhone] = true;
      }
      let  { intentionClue, addIntentionClue} = this;
      if (addIntentionClue && intentionClue.content.trim().length == 0) {
        this.$toast("请输入意向课程");
        return false;
      }
      if (addIntentionClue && intentionClue.level === 0) {
        this.$toast("请输入选择成交意向");
        return false;
      }
      // 等待请求完成，再确认是否提交
      if (this.nameValidating) {
        this.showLoading();
        try{
          await this.nameValidating;
        } catch (err) {
          console.log(err)
        }
        this.$toast.clear();
      }

      // 判断是否有重名提示示处理
      if (this.isRepetitive && !this.confirmNotRepetitive) {
        this.$toast(`${(this.duplicateClueData && !this.duplicateClueData.enableAddOrUpdate)?'存在':'有可能'}重复的学员/意向${(this.duplicateClueData && !this.duplicateClueData.enableAddOrUpdate)?'':'，请先进行确认。'}`);
        this.$router.push('/baseStudentNameRepetitive?scoped=意向或学员&old=true&entry=2');
        return false;
      }

      this.showLoading();
      let params = Object.assign(this.studentInfos, {
            studentParentRelation: relationTels,
            name: name.trim(),
            customFieldList: this.customFieldList,
          })
      if (this.addIntentionClue) {
        params.intentionClue = this.intentionClue;
      }
      
      this.$api.studentAdd(params)
        .then(res => {
          vant.Toast.clear();
          // 如果后端接口不返回id，不跳转到下一步
          if (res.code === 810000010) {
            let { intentionClueList = [], studentList = []} = res.data;
            this.showDialog = true;
            this.duplicateDatas = studentList.concat(intentionClueList.map(v=>({...v, type: 1})))
            return false;
          }
          if (!res.data.id) {
            app.http.tipErr(res.msg || '网络异常，请稍后重试');
            return false;
          }
          if (res.code > 60000) {
            app.http.tipErr(res.msg || '网络异常，请稍后重试');
          }
          // 重新进行一次校验
          this.reValidateName();
          if (res.code === 200) {
            this.$toast.success('登记学员成功');
            this.$router.push('/studentChooseClass?id=' + res.data.id);
          }
        })
        .catch(err => {
          console.log(err);
          vant.$toast.clear();
        });
    },
    // 选择关系
    pickerRelation(idx) {
      let parentInfos = this.studentInfos.relationTels[idx];
      app.x3.picker
        .relation(parentInfos.relation, {
          title: '请选择关系',
        })
        .then(res => {
          this.$set(this.studentInfos.relationTels[idx], 'relation', res);
        });
    },
    async selectFollowTeacher() { //选择跟进老师
      let res = await app.x3.side.xsTeacher({
        ids: this.studentInfos.followTeacherList.map(i=>i.followTeacherId),
        list: this.studentInfos.followTeacherList.map(({followTeacherId,followTeacherName})=>({id:followTeacherId,name:followTeacherName})),
        params: {
          statusList: [1],
          campusIds: this.studentInfos.campusId ? [this.studentInfos.campusId] : []
        }
      });
      this.studentInfos.followTeacherList = res.list.map(i=>{
        return {
          followTeacherId: i.id,
          followTeacherName: i.name,
        }
      });
    },
    delFollowTeacher(index) { // 移除某个已选的跟进老师
      this.studentInfos.followTeacherList.splice(index, 1);
    },
    changeOften(item) {
      if (item.often) return false;
      let relationTels = this.studentInfos.relationTels || [];
      relationTels.forEach(v=>this.$set(v, 'often', false));
      this.$set(item, 'often', true);
    },
    sexClickFn(index) {
      if (index == this.oldSexValue) {
        this.studentInfos.sex = 2;
        this.oldSexValue = 2;
      } else {
        this.oldSexValue = index;
      }
    }
  },
  destroyed() {},
};
</script>

<style lang="scss">
.yunxiao.old-student-input {
  display: flex;
  flex-direction: column;
  height: 100%;
  .contain {
    flex: 1;
    color: var(--g8);
    overflow-y: auto;
    .repetitive-tips {
      display: flex;
      box-sizing: border-box;
      margin: 0;
      padding: calc(var(--gap) * 10) calc(var(--gap) * 16);
      width: 100%;
      text-align: right;
      color: var(--c5);
      justify-content: space-between;
      // font-size:var(--fs-sm);
      // line-height:var(--lh-sm);
      background-color: rgba(var(--c5-rgb), 0.1);
      text-align: left;
      >span{
        padding-left: calc(var(--gap) * 5);
        white-space: nowrap;
      }
    }
    .info-wrapper {
      font-size: var(--fs-md);
      background-color: var(--white);
      padding: 0 calc(var(--gap) * 16);
      .info-item {
        padding: calc(var(--gap) * 12) 0;
        min-height: calc(var(--w) * 54);
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:not(:last-child) {
          border-bottom: 0.5px solid var(--g3);
        }
        .item-add-btn {
          color: #1890ff;
          font-size: var(--fs-lg);
          font-size: var(--fs-lg);
          > .van-icon {
            margin-right: calc(var(--gap) * 4);
            vertical-align: text-top;
          }
        }
        .item-right {
          text-align: right;
          display: flex;
          align-items: center;
          &.placeholder {
            color: var(--g5);
          }
          .item-icon {
            font-size: var(--fs-lg);
            line-height: var(--lh-lg);
            margin-left: calc(var(--gap) * 8);
            color: var(--g6);
          }
        }
      }
      .info-item.add-btns {
        justify-content: flex-start;
        align-items: center;
        color: var(--c1);
        .vxs-icon-system_add {
          margin-right: calc(var(--gap) * 4);
        }
      }
      .van-cell {
        padding: calc(var(--gap) * 12) 0;
        &::after {
          right: 0px;
          left: 0px;
        }
        .van-cell__title {
          color: var(--g8);
        }
        .van-field__body {
          padding-right: calc(var(--gap) * 6);
        }
        .input-solt-field {
          padding: 0;
          .van-field__body {
            padding-right: 0;
          }
        }
        .parent-field {
          display: flex;
          .van-cell__title {
            width: auto;
            margin-right: calc(var(--gap) * 12);
          }
          .van-cell__value {
            flex: 1;
          }
        }
        .relation-nav {
          display: flex;
          align-items: center;
          .required-relation{
            display: flex;
            width: calc(var(--w) * 16);
            margin-right: calc(var(--gap) * 8);
            color: var(--c3);
            align-items: center;
            justify-content: center;
            font-size:var(--fs-lg);
            &::before{
              display: block;
              content:"*";
              height: calc(var(--w) * 16);
            }
          }
          .delete-relation {
            color: var(--black);
            margin-right: calc(var(--gap) * 4);
          }
          .van-icon-arrow-down {
            color: var(--g4);
            margin-left:calc(var(--gap) * 4);
          }
          &.placeholder {
            color: var(--g5);
          }
        }
      }
      .info-item .item-label.required {
        &::before {
          margin-left: -5px;
          margin-right: 1px;
          color: var(--c3);
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
          content: '*';
        }
      }
      > .van-cell--required::before,
      .info-item > .van-cell--required::before {
        display: none;
      }
      .info-item > .van-cell {
        padding: 0;
      }
      .repetitive-tips {
        box-sizing: border-box;
        padding-right: calc(var(--gap) * 6);
        margin: calc(var(--gap) * 8) 0 calc(var(--gap) * 10) 0;
        width: 100%;
        text-align: right;
        color: var(--g6);
        > span {
          color: var(--c1);
        }
      }
      .teacher-cell {
        margin-top: calc(var(--gap) * 24);
        .van-cell__value {
          // font-size:var(--fs-lg);
          .vu {
            color: var(--g8);
          }
          .txt-btn {
            font-size:var(--fs-sm);
            color: var(--tlc);
          }
        }
        .placeholder {
          color: var(--g5);
        }
      }
      .right-column-tips{
        text-align: right;
        color: var(--g6);
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        padding-top: calc(var(--gap) * 12);
      }
      .right-radio-column{
        display: flex;
        width: 7em;
        align-items: center;
        justify-content: center;
        color: var(--g6);
        .circle{
          width: calc(var(--w) * 14);
          height: calc(var(--w) * 14);
          border-radius: 50%;
          border: 1px solid var(--g6);
        }
        &.active{
          color: var(--c1);
          .circle{
            display: flex;
            margin: calc(var(--w) * -1) 0 0 calc(var(--w) * 1);
            border-color: var(--c1);
            align-items: center;
            justify-content: center;
            &::before{
              content:'';
              display: block;              
              width: calc(var(--w) * 6);
              height: calc(var(--w) * 6);
              border-radius: 50%;
              background-color: var(--c1);
            }
          }
        }
      }
    }
    .follow-teacher-tips {
      margin-bottom: calc(var(--gap) * 10);
      padding: calc(var(--gap) * 6) calc(var(--gap) * 16);
      color: var(--g6);
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
    }
    .name-wrapper {
      overflow: hidden;
      // margin-bottom: calc(var(--gap) * 24);
      .van-cell {
        &::after {
          display: none;
        }
      }
    }
    .line-title {
      display: flex;
      padding: 0px calc(var(--gap) * 15);
      min-height: calc(var(--w) * 40);
      color: var(--g8);
      line-height: calc(var(--w) * 40);
      box-sizing: border-box;
      align-items: center;
      &.required {
        &::before {
          margin-left: -5px;
          color: var(--c3);
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
          content: '*';
        }
      }
      &.top-tips {
        margin: calc(var(--gap) * 12) 0 calc(var(--gap) * 8) 0;
      }
      .tips {
        display: inline-block;
        color: var(--g6);
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
      }
      .van-popover__wrapper {
        margin-left: calc(var(--gap) * 4);
        height: calc(var(--w) * 18);
        line-height: var(--lh-lg);
      }
    }
  }
  .custom-fields-nav{
    .van-field__right-icon{
      padding: 0 0 0 calc(var(--gap) * 8);
    }
  }
}
</style>
<style lang="scss" scoped>
.as1wrap {
  .head {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .clearbtn {
      position: absolute;
      right: calc(var(--gap) * 16);
      top: 50%;
      color: var(--tlc);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: 6px;
      transform: translate3d(0, -50%, 0);
      margin-right: -6px;
    }
  }
  .linewrap {
    padding: 0 calc(var(--gap) * 16);
    .line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: calc(var(--gap) * 8) 0;
      .l {
        .name {
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
          color: var(--g8);
        }
      }
      .r {
        line-height: 0;
        padding: 8px;
        margin-right: -8px;
      }
    }
  }
}
</style>